import {
  PaymentFormValues,
  RegistrationFormValues,
  EmailVerificationFormValues,
  EmailFormValues,
} from '@/enums/forms'

export const paymentFieldsKeys = [
  PaymentFormValues.card,
  PaymentFormValues.cardholderName,
  PaymentFormValues.exp,
  PaymentFormValues.cvv,
] as Array<keyof typeof PaymentFormValues>

export const registrationFieldsKeys = [RegistrationFormValues.email] as Array<
  keyof typeof RegistrationFormValues
>

export const emailVerificationFieldsKeys = [EmailVerificationFormValues.code] as Array<
  keyof typeof EmailVerificationFormValues
>

export const emailFormFieldsKeys = [EmailFormValues.email] as Array<keyof typeof EmailFormValues>
